import { render, staticRenderFns } from "./SubscriptionBot.vue?vue&type=template&id=5197338c"
import script from "./SubscriptionBot.vue?vue&type=script&lang=ts"
export * from "./SubscriptionBot.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionBot.vue?vue&type=style&index=0&id=5197338c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports